import React, { useState, useRef, useEffect } from 'react';
import './SelectorColumnas.css';

/**
 * Selector múltiple en estilo "selector de columnas": botón que abre dropdown con lista de checkboxes y "Listo".
 * valueType: 'number' (default) o 'string' para valores como 'caja_1', 'cuenta_2'.
 */
export function SelectorMultiFicha({ opciones, selectedIds, onChange, titulo, labelBoton, valueType = 'number' }) {
  const [abierto, setAbierto] = useState(false);
  const [localIds, setLocalIds] = useState([]);
  const ref = useRef(null);
  const isString = valueType === 'string';

  const ids = Array.isArray(selectedIds) ? selectedIds : (selectedIds != null && selectedIds !== '' ? [selectedIds] : []);

  useEffect(() => {
    if (abierto) setLocalIds([...ids]);
  }, [abierto, ids]);

  const norm = (v) => (isString ? v : (typeof v === 'number' ? v : Number(v)));
  const isChecked = (value) => localIds.includes(norm(value));

  const handleToggle = (value) => {
    const n = norm(value);
    setLocalIds((prev) =>
      prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n]
    );
  };

  const handleCerrar = () => {
    onChange(localIds);
    setAbierto(false);
  };

  const handleToggleBoton = () => {
    if (abierto) onChange(localIds);
    setAbierto((o) => !o);
  };

  const textoBoton = labelBoton || titulo;
  const count = ids.length;
  const label = count > 0 ? `${textoBoton} (${count})` : textoBoton;

  return (
    <div className="form-group selector-columnas selector-multi-ficha-wrap" ref={ref} style={{ position: 'relative' }}>
      <span className="form-label-inline" style={{ display: 'block', marginBottom: 6 }}>{titulo}</span>
      <button
        type="button"
        className="btn-selector-columnas"
        onClick={handleToggleBoton}
        title={titulo}
        aria-expanded={abierto}
        aria-haspopup="true"
      >
        ⚙️ {label}
      </button>
      {abierto && (
        <div
          className="selector-columnas-dropdown"
          role="dialog"
          aria-label={titulo}
          style={{ position: 'absolute', marginTop: 4, zIndex: 1000 }}
        >
          <div className="selector-columnas-header">
            <span>{titulo}</span>
          </div>
          <ul className="selector-columnas-lista">
            {(opciones || []).slice(0, 200).map((opt) => (
              <li key={opt.value}>
                <label className="selector-columnas-label">
                  <input
                    type="checkbox"
                    checked={isChecked(opt.value)}
                    onChange={() => handleToggle(opt.value)}
                  />
                  <span>{opt.label}</span>
                </label>
              </li>
            ))}
          </ul>
          {opciones && opciones.length > 200 && (
            <p className="selector-columnas-hint">Mostrando 200 de {opciones.length}</p>
          )}
          <div className="selector-columnas-footer">
            <button type="button" className="selector-columnas-cerrar" onClick={handleCerrar}>
              Listo
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
